import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';

const Header = () => {
    const navigate = useNavigate();
    const { logout } = useContext(AuthContext);

    const handleLogout = () => {
        logout()
        navigate('/login'); // Redirect to login page after logout
    };
    return (
        <nav className="main-header navbar navbar-expand navbar-maroon navbar-dark">
            {/*Left navbar links */}
            <ul className="navbar-nav">
                <li className="nav-item">
                    <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <a href="/" className="nav-link">Home</a>
                </li>
            </ul>

            {/* Right navbar links */}
            <ul className="navbar-nav ml-auto">
                
                <li className="nav-item">
                    <a className="nav-link" data-widget="fullscreen" href="#" role="button">
                        <i className="fas fa-expand-arrows-alt"></i>
                    </a>
                </li>

                {/* Notifications Dropdown Menu */}
                <li className="nav-item dropdown">
                    <a className="nav-link" data-toggle="dropdown" href="#">
                        <div className="user-panel d-flex">
                            <img src="dist/img/userpic.png" className="img-circle elevation-2" alt="User" />
                        </div>
                    </a>
                    <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <a href="/profile" className="dropdown-item">
                            <i className="fas fa-user mr-2"></i> Profile
                        </a>
                        <div className="dropdown-divider"></div>
                        <a href="/changepassword" className="dropdown-item">
                            <i className="fas fa-key mr-2"></i> Change Password
                        </a>
                        <div className="dropdown-divider"></div>
                        <button  className="dropdown-item" onClick={handleLogout}>
                            <i className="fas fa-arrow-right mr-2"></i> Logout
                        </button >
                    </div>
                </li>
            </ul>
        </nav>
    )
}

export default Header